import React, { useCallback, useMemo } from 'react';
import AlertDialog from '@/components/atom/AlertDialog';
import CommonDialog from '@/components/atom/Dialog';
import ConfirmDialog from '@/components/organism/ConfirmDialog';

export enum DialogType {
  COMMON,
  ALERT,
  CONFIRM_DIALOG,
}

interface UseDialog {
  type: DialogType;
}

const useDialog = ({ type }: UseDialog) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const openDialog = useCallback(() => setIsOpen(true), []);
  const closeDialog = useCallback(() => setIsOpen(false), []);

  const Dialog = useMemo(() => {
    switch (type) {
      case DialogType.ALERT:
        return AlertDialog;
      case DialogType.CONFIRM_DIALOG:
        return ConfirmDialog;
      case DialogType.COMMON:
        return CommonDialog;
      default:
        return CommonDialog;
    }
  }, [type]);

  return { Dialog, isOpen, openDialog, closeDialog };
};

export default useDialog;
